import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-paging',
  templateUrl: './paging.component.html',
  styleUrls: ['./paging.component.scss']
})
export class PagingComponent implements OnInit {

  @Input() totalRecords
  @Input() numRecordsToPage
  PageNo = 1 
  numAllPages = 0 //סך כל העמודים
  @Output() currentPageChanged: EventEmitter<any> = new EventEmitter<any>()

  constructor() { }

  ngOnInit(): void {
    var numPages = this.totalRecords / this.numRecordsToPage;
    this.numAllPages = Number.isInteger(numPages) ? numPages : Math.ceil(numPages); 
  }

  prevPage() {
    if (this.PageNo >= 2){
      this.PageNo -= 1;
      this.currentPageChanged.emit(this.PageNo);
    }
  }

  nextPage() {
    if (this.PageNo < this.numAllPages){
        this.PageNo += 1;
      this.currentPageChanged.emit(this.PageNo);
    }
  }
}
